import { VeloThemeContext } from 'velo-react-components';

const useActiveTheme = () => {
  const [theme, onThemeChange] = VeloThemeContext.useVeloThemeContext();

  return [theme, onThemeChange];
};

export { useActiveTheme };
